import * as React from "react";
import "./Company.css";
import { Helmet } from "react-helmet-async";

export default function OurCompany() {
  <Helmet>
    <title>Our Company. – Ponvel Exim</title>
    <meta name="description" content="View Ponvel Exim’s Our Company" />
    <meta name="keywords" content="Ponvel Exim Our Company Profile," />
    <link rel="canonical" href="https://ponvelexim.com/our-company" />

    {/* Open Graph */}
    <meta property="og:site_name" content="Ponvel Exim" />
    <meta property="og:locale" content="en_IN" />
    <meta property="og:title" content="Our Company. – Ponvel Exim" />
    <meta
      property="og:description"
      content="Check Ponvel Exim’s Our Company."
    />
    <meta property="og:image" content="https://ponvelexim.com/logo192.png" />
    <meta property="og:url" content="https://ponvelexim.com/our-company" />
    <meta property="og:type" content="website" />

    {/* Twitter */}
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content="Our Company – Ponvel Exim" />
    <meta name="twitter:description" content="Check Ponvel Exim’s Company." />
    <meta name="twitter:image" content="https://ponvelexim.com/logo192.png" />
  </Helmet>;

  return (
    <>
      <div className="Company-container">
        <h2>PONVEL EXIM</h2>
        <h3>Your Trusted Export Partner from India</h3>
        <div>
          <p>
            PONVEL EXIM is an India-based export and import company specializing
            in supplying quality-assured Indian products to global markets.
            Headquartered in Tiruppur, Tamil Nadu, we focus on delivering
            reliable sourcing, competitive pricing, and consistent export
            performance for international buyers.
          </p>
          <p>
            We act as a single export partner for multiple product categories,
            helping importers simplify procurement while ensuring compliance,
            quality, and timely delivery.
          </p>
        </div>
        <div>
          <h2>Export-Driven Expertise</h2>
          <p>
            At PONVEL EXIM, exports are at the core of everything we do. From
            product selection to packaging and logistics, our processes are
            designed to meet international trade standards and market-specific
            requirements.
          </p>
          We support:
          <li>Bulk & container-load exports</li>
          <li>Private label & customized packaging</li>
          <li>FOB, CIF & CNF pricing options</li>
          <li>Market-specific product compliance</li>
          <li>Complete export documentation</li>
        </div>
        <div>
          <h2>Our Export Product Portfolio</h2>
          <h3>Food & Confectionery Exports</h3>
          <li>Biscuits & Cookies</li>
          <li>Cream Biscuits & Wafers</li>
          <li>Wafer Rolls</li>
          <li>Lollipops, Candies, Toffees & Bubble Gum</li>
          <li>Chocolates & Sugar Confectionery</li>

          <h3>Home Care & Personal Care Exports</h3>
          <li>Home cleaning products</li>
          <li>Laundry & hygiene solutions</li>
          <li>Custom branding & private labeling</li>

          <h3>Textile & Home Textile Exports</h3>
          <li>Garments & apparel</li>
          <li>Aprons, mats, pillow covers & utility textiles</li>
        </div>
        <div>
          <h2>Why Global Buyers Choose PONVEL EXIM</h2>

          <li>Export-ready manufacturing partners</li>
          <li>Consistent product quality & inspections</li>
          <li>Competitive international pricing</li>
          <li> Reliable production timelines</li>
          <li>Strong packaging & labeling standards</li>
          <li>End-to-end logistics coordination</li>
          <p>
            We focus on long-term buyer relationships, not just one-time
            shipments.
          </p>
        </div>
        <div>
          <h2>Our Global Markets</h2>
          <p>
            PONVEL EXIM actively exports to <b>African markets</b>, including:
          </p>
          <li> Nigeria</li>
          <li>Kenya</li>
          <li>Ghana</li>
          <li>South Africa</li>
          <p>
            We are continuously expanding into
            <b>new international territories</b> based on buyer demand.
          </p>
        </div>
        <div>
          <h2>Our Export Mission</h2>
          <p>
            To be a trusted global trade partner, delivering India’s finest
            products with quality, sustainability, and excellence."
          </p>
        </div>
        <div>
          <h2>Our Export Vision</h2>
          <p>
            "To empower Indian SMEs and MSMEs to expand globally by providing
            comprehensive export-import solutions that ensure seamless trade and
            sustainable business growth."
          </p>
        </div>
        <div>
          <h2>Work With Us</h2>
          <p>
            If you are an{" "}
            <b>importer, distributor, wholesaler, or brand owner</b> looking for
            a dependable export partner from India, <b>PONVEL EXIM</b> is ready
            to support your growth.
          </p>
          <p>
            <b>
              Contact us today for product catalogs, specifications, and export
              pricing.
            </b>
          </p>
        </div>
      </div>
    </>
  );
}
